// import {FC} from 'react'


const LabRoomCell = (props: any) => {
  return (
    <div className='d-flex ms-5'>
      <div className='d-flex flex-row col '>
        <div className='d-flex flex-row align-items-center '>
          <span className='text-black fw-bold fs-7 '>
            {props?.tableProps?.labRoomName ? props?.tableProps?.labRoomName : 'N/A'}
          </span>
        </div>
      </div>
    </div>
  )
}

export {LabRoomCell}
